import React, { useEffect, useState } from 'react';
import { Button, Spinner, Typography } from 'seagull';
import { StepTemplate } from "../StepTemplate";
import { Step } from "../VendorOnboardingModal.utils";
import styles from "./QBOSetupStep.module.scss";
import { useQboInVob } from "../useQboInVob";
import sortBy from 'lodash/sortBy';
import { useOnMount } from "../../../hooks/useOnMount";
import { VobQboState } from "../../../types/api.model";
import { AccountRow, LinkType } from "./AccountRow";
export function QBOSetupStep(props) {
  var _integration$accounts, _integration$accounts2, _integration$accounts3;
  const {
    onContinue
  } = props;
  const {
    getQboAccounts,
    waitForReadyIntegration,
    setPendingConnect
  } = useQboInVob();
  const [qboAccounts, setQboAccounts] = useState();
  const [integration, setIntegration] = useState();
  useOnMount(() => {
    setPendingConnect(VobQboState.Done);
  });
  useEffect(() => {
    waitForReadyIntegration().then(async integration => {
      const accounts = await getQboAccounts();
      const sortedAccounts = {
        bank: sortBy(accounts.bank, account => account.name),
        expense: sortBy(accounts.expense, account => account.name),
        clearing: sortBy(accounts.clearing, account => account.name)
      };
      setQboAccounts(sortedAccounts);
      setIntegration(integration);
    });
  }, []);
  return /*#__PURE__*/React.createElement(StepTemplate, {
    currentStep: Step.QBOSetup,
    stepper: "Step 3 of 3",
    header: "Connect to QuickBooks Online",
    subHeader: "Choose the accounts you'd like to use. Don't worry, you can change it anytime.",
    footer: /*#__PURE__*/React.createElement("div", {
      className: styles.bottom
    }, /*#__PURE__*/React.createElement(Button, {
      "data-testid": "vob-step-".concat(Step.QBOSetup, "-continue"),
      onClick: () => onContinue(true)
    }, "Continue to Anchor"))
  }, integration ? /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(AccountRow, {
    linkType: LinkType.Bank,
    initialValue: integration === null || integration === void 0 || (_integration$accounts = integration.accounts) === null || _integration$accounts === void 0 || (_integration$accounts = _integration$accounts.bank) === null || _integration$accounts === void 0 || (_integration$accounts = _integration$accounts.synced) === null || _integration$accounts === void 0 ? void 0 : _integration$accounts.integratedId,
    qboAccounts: (qboAccounts === null || qboAccounts === void 0 ? void 0 : qboAccounts.bank) || undefined,
    placeholder: "Choose a bank account for deposited funds",
    noOptionsText: "No Savings or Checking accounts to show"
  }), /*#__PURE__*/React.createElement(AccountRow, {
    linkType: LinkType.Expense,
    initialValue: integration === null || integration === void 0 || (_integration$accounts2 = integration.accounts) === null || _integration$accounts2 === void 0 || (_integration$accounts2 = _integration$accounts2.expense) === null || _integration$accounts2 === void 0 || (_integration$accounts2 = _integration$accounts2.synced) === null || _integration$accounts2 === void 0 ? void 0 : _integration$accounts2.integratedId,
    qboAccounts: (qboAccounts === null || qboAccounts === void 0 ? void 0 : qboAccounts.expense) || undefined,
    placeholder: "Choose an expense account for merchant fees"
  }), /*#__PURE__*/React.createElement(AccountRow, {
    linkType: LinkType.Clearing,
    initialValue: integration === null || integration === void 0 || (_integration$accounts3 = integration.accounts) === null || _integration$accounts3 === void 0 || (_integration$accounts3 = _integration$accounts3.clearing) === null || _integration$accounts3 === void 0 || (_integration$accounts3 = _integration$accounts3.synced) === null || _integration$accounts3 === void 0 ? void 0 : _integration$accounts3.integratedId,
    qboAccounts: (qboAccounts === null || qboAccounts === void 0 ? void 0 : qboAccounts.clearing) || undefined,
    placeholder: "Choose a clearing account for collected funds"
  })) : /*#__PURE__*/React.createElement("div", {
    "data-testid": "pending-accounts-spinner",
    className: styles.spinnerContainer
  }, /*#__PURE__*/React.createElement(Spinner, null), /*#__PURE__*/React.createElement(Typography, null, "Just a moment, bringing QuickBooks data to you...")));
}